import React from 'react'
import { useHistory } from 'react-router-dom'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'
import { giftHide } from '../../../api/gifts'
import { useDispatch } from 'react-redux'
import './giftButtons.sass'
import { switchHideShowGift } from '../../../store/member/memberSlice'

interface Props {
    recipient: string
    recipientId?: number
    giftId: string | number
    giftStatus: string
}

const GiftButtons = ({ recipient, giftId, recipientId, giftStatus }: Props) => {
    const history = useHistory()
    const dispatch = useDispatch()

    const handleRedirectToGiftCatalog = () => {
        history.push({
            pathname: createLocalizedPath(paths.virtualGiftCatalog.path),
            search: `?r=` + recipient
        })
    }

    const handleSendMessage = () => {
        history.push({
            pathname: createLocalizedPath(paths.memberMessagePmConversations.path),
            search: `?pm=` + recipientId
        })
    }

    const handleHideGift = () => {
        giftHide({ id: giftId })
            .then((res) => {
                if (res.status == 'success') dispatch(switchHideShowGift(giftId))
            })
            .catch((e) => console.log(e))
    }

    return (
        <div className="giftButtonContainer myGiftsButtonContainer">
            {recipient && (
                <>
                    <img src={require('./../../../assets/ic-gift-blue.svg')} onClick={handleRedirectToGiftCatalog} />
                    <img src={require('./../../../assets/ic-message.svg')} onClick={handleSendMessage} />
                </>
            )}
            <img
                src={
                    giftStatus === 'hidden'
                        ? require('./../../../assets/ic-eye.svg')
                        : require('./../../../assets/ic-eye-cross.svg')
                }
                onClick={handleHideGift}
            />
        </div>
    )
}

export default GiftButtons
